var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info',[_c('h1',[_vm._v(_vm._s(_vm.$t("ABOUT_APPDB")))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('ABOUT_APPDB_DESC'))}}),_c('template',{slot:"sidebar"},[_c('h2',[_vm._v(_vm._s(_vm.$t("DONATIONS")))]),_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.$t('WE_ARE_ALWAYS_OPEN_DONATIONS', {
          bitcoinAddress: '1AZsEJvZYtH9An4iJi1QJa2tiNMKYgNTvN',
        }) +
        `. ETH: <strong>0xc21350edf0C7a0998fDd264eBaDd5772f2e317B5</strong>`
      )}}),(_vm.BRAND_KEY === 'appdb')?[_c('h2',[_vm._v(_vm._s(_vm.$t("STAY TUNED")))]),_c('html-with-links',{attrs:{"tag":"p","html":_vm.$t('APPDB_SOCIAL', {
            twitterLink: 'https://twitter.com/appdb_official',
            storyLink: '/info/empire-strikes-back',
          })}})]:_vm._e()],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }